import { useEffect, useState } from "react";
import { ListItem } from "./ListItem";
import { data } from "../data/data";

interface ListProps {
  scale: number;
  animate: boolean;
  setAnimate: (value: any) => void;
}

export const List = ({ scale, animate, setAnimate }: ListProps) => {
  const [list, setList] = useState([]);

  useEffect(() => {
    const newList: any = data
      .filter((d) => d.rating >= 1 && d.rating <= scale)
      .sort((a, b) => {
        if (a.rating < b.rating) return 1;
        if (a.rating > b.rating) return -1;
        return 0;
      });
    setList(newList);
    setAnimate((s: boolean) => !s);
    setTimeout(() => {
      setAnimate(false);
    }, 500);
  }, [scale, setAnimate]);

  return (
    <ul className={`list ${animate ? "grow" : ""}`}>
      {list.map((obj: Record<string, any>, index: number) => (
        <ListItem
          key={obj.team}
          team={obj.team}
          link={obj.link}
          description={obj.description}
          sauce={obj.sauce}
        />
      ))}
      <li className="placeholder" />
      <li className="placeholder" />
    </ul>
  );
};
